{
  "de": {
    "whats_new": {
      "category": {
        "news": "Neuigkeit",
        "product": "Produktupdate",
        "tip": "Tipp"
      },
      "category_plural": {
        "news": "Neuigkeiten",
        "product": "Produktupdates",
        "tip": "Tipps"
      },
      "earlier": "Früher",
      "empty_description": "Neue Funktionen, Tipps und Neuigkeiten von Ziggu erscheinen hier.",
      "empty_title": "Noch keine Beiträge",
      "helpful": "Hilfreich",
      "helpful_impersonation": "Während einer Identitätsübernahme ist das nicht möglich.",
      "helpful_mark": "Als hilfreich markieren",
      "helpful_marked": "Sie fanden das hilfreich",
      "image_open": "Bild {index} von {count} öffnen",
      "load_failed_description": "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "load_failed_title": "Beiträge konnten nicht geladen werden",
      "new": "Neu",
      "no_matches_description": "Keine Beiträge passen zu Ihrer Suche oder Ihren Filtern. Leeren Sie die Filter, um alles zu sehen.",
      "no_matches_title": "Keine Treffer",
      "read_more": "Mehr lesen",
      "retry": "Erneut versuchen",
      "search": "Beiträge durchsuchen…",
      "subtitle": "Neue Funktionen, Tipps und Neuigkeiten vom Ziggu-Team.",
      "title": "Was ist neu"
    }
  }
}
